export type ValidationError = {
  field: string
  message: string
  stepName: string
}

export const validateFormData = (
  formData: any,
  t: any,
  validateLocation: boolean = true,
): ValidationError[] => {
  const errors: ValidationError[] = []

  if (!formData.title || formData.title.length < 5) {
    errors.push({
      field: 'title',
      message: t('create-ad.title-too-short'),
      stepName: t('create-ad.announce'),
    })
  }

  if (!formData.description || formData.description.length < 130) {
    errors.push({
      field: 'description',
      message: t('create-ad.description-too-short'),
      stepName: t('create-ad.announce'),
    })
  }

  return errors
}
